// extracted by mini-css-extract-plugin
export default {"headerContent":"rA0N0","title":"t4T0v"};